import ReactCountryFlag from 'react-country-flag';

interface CountryFlagProps {
  countryCode?: string | null;
  size?: number;
  title?: string;
  className?: string;
}

export default function CountryFlag({
  countryCode,
  size = 16,
  title,
  className,
}: CountryFlagProps) {
  const normalizedCountryCode = typeof countryCode === 'string'
    ? countryCode.trim().toUpperCase()
    : '';

  const wrapperClass = 'inline-flex items-center justify-center rounded-ggc-pill overflow-hidden border border-black/12 bg-white shrink-0 leading-none';
  const wrapperStyle = {
    width: size,
    height: size,
    minWidth: size,
  } as const;

  if (!normalizedCountryCode) {
    return (
      <span className={`${wrapperClass}${className ? ` ${className}` : ''}`} style={wrapperStyle} title={title}>
        <i
          className="fa fa-globe"
          style={{ fontSize: Math.max(10, Math.round(size)), color: 'var(--ggc-disabled)' }}
          aria-hidden
        />
      </span>
    );
  }

  return (
    <span className={`${wrapperClass}${className ? ` ${className}` : ''}`} style={wrapperStyle} title={title}>
      {/* 원형 마스크 안에서도 국기 비율이 덜 찌그러지도록 가로폭을 조금 넓게 렌더링한다. */}
      <ReactCountryFlag
        countryCode={normalizedCountryCode}
        svg
        style={{
          width: Math.round(size * 1.35),
          height: size,
          maxWidth: 'none',
          flexShrink: 0,
        }}
      />
    </span>
  );
}
